import { z } from 'zod';
import { auditSchema, hexColorSchema, idSchema, isoDateSchema } from '../../common.js';
/** Yjs doc holding birthdays, member prefs and (Phase 2) meal-plan slots. */
export const HOUSEHOLD_DOC = 'household';
/**
 * Collaborative view of a household member. Identity itself lives in Postgres
 * (`users`, owned by WS-2); this is the shareable profile the UI renders.
 */
export const householdMemberSchema = z.object({
    id: idSchema,
    name: z.string().min(1).max(100),
    color: hexColorSchema,
    avatarEmoji: z.string().max(8).optional(),
});
export const birthdaySchema = auditSchema.extend({
    id: idSchema,
    name: z.string().min(1).max(100),
    /** Full date; year may be a placeholder when unknown — see `yearKnown`. */
    date: isoDateSchema,
    yearKnown: z.boolean(),
    /** Set when the birthday belongs to a household member. */
    memberId: idSchema.optional(),
    notes: z.string().max(2000).optional(),
});
//# sourceMappingURL=index.js.map